import { Component, computed, inject } from '@angular/core';
import { LayoutService } from '@core/diamond/service/layout.service';
import { TimezoneService } from '@shared/services';

@Component({
  selector: '[app-footer]',
  standalone: true,
  template: `
    <div class="layout-footer">
      <div class="footer-logo-container">
        <img src="/layout/images/isotype-dark.svg" alt="diamond-layout" />
        <div class="text-xs ml-4 text-muted-color gap-4 flex items-center">
          <a href="https://bitappcloud.statuspage.io/" target="_blank"> Status</a>
          •
          <a href="https://bitappcloud.com/politica-privacidad/" target="_blank"> Privacidad</a>
        </div>
        <!--
        <span class="footer-app-name">DIAMOND</span>
        -->
      </div>
      <span class="footer-copyright">&#169; Bit-Office - {{ year }}</span>
    </div>
  `,
})
export class AppFooter {
  layoutService = inject(LayoutService);
  timezoneService = inject(TimezoneService);

  isDarkTheme = computed(() => this.layoutService.isDarkTheme());

  year: number = this.timezoneService.today().getFullYear();
}
